import {
  COMMON_PROPERTY_SCHEMA_NAMES,
  DYNAMIC_PROPERTY_SCHEMA_NAMES,
  FIELD_PROPERTY_SCHEMA_NAMES,
  FORM_PROPERTY_SCHEMA_NAMES,
  GROUP_PROPERTY_SCHEMA_NAMES,
} from '../../../store/modules/form-designer/constants/schema-names'
import { FIELD_PROPERTY_NAMES } from '../../../store/modules/form-designer/constants/property-names'

export const LABELS = {
  [COMMON_PROPERTY_SCHEMA_NAMES.NAME]: 'name',
  [COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME]: 'form_designer_display_name',
  [COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY]: 'form_designer_localization_key',
  [COMMON_PROPERTY_SCHEMA_NAMES.DESCRIPTION]: 'form_designer_description',
  [GROUP_PROPERTY_SCHEMA_NAMES.INVISIBLE_BORDER]: 'form_designer_hidden_border',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.LABEL_EXP]: 'form_designer_label_by_expression',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP]: 'form_designer_hidden',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP]: 'form_designer_read_only',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.COLLAPSED_EXP]: 'form_designer_collapsed_by_expression',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.SAVE_EXP]: 'form_designer_save_expression',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.REQUIRED_EXP]: 'form_designer_required',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.VALUE_EXP]: 'form_designer_value_by_expression',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.LIST_EXP]: 'form_designer_list_by_expression',
  [DYNAMIC_PROPERTY_SCHEMA_NAMES.FILTER_EXP]: 'form_designer_filter_by_expression',
  [FORM_PROPERTY_SCHEMA_NAMES.SYSTEM]: 'form_designer_subsystem',
  [FORM_PROPERTY_SCHEMA_NAMES.MAIN_TABLE]: 'form_designer_main_table',
  [FORM_PROPERTY_SCHEMA_NAMES.URL]: 'form_designer_form_url',
  [FORM_PROPERTY_SCHEMA_NAMES.TAGS]: 'form_designer_form_tags',
  [FORM_PROPERTY_SCHEMA_NAMES.MENU_ASSIGNER]: 'form_designer_assign_route_to_menu',
  [FIELD_PROPERTY_SCHEMA_NAMES.PLACEHOLDER]: 'form_designer_placeholder',
  [FIELD_PROPERTY_SCHEMA_NAMES.DATE_PICKER_VIEW]: 'form_designer_date_picker_view',
  [FIELD_PROPERTY_SCHEMA_NAMES.READ_ONLY]: 'form_designer_read_only',
  [FIELD_PROPERTY_SCHEMA_NAMES.HIDDEN]: 'form_designer_hidden',
  [FIELD_PROPERTY_SCHEMA_NAMES.REF_TABLE]: 'form_designer_ref_table_name',
  [FIELD_PROPERTY_SCHEMA_NAMES.SAVE_DATA]: 'form_designer_save_data_into_db',
  [FIELD_PROPERTY_SCHEMA_NAMES.NO_CLONING]: 'form_designer_no_cloning',
  [FIELD_PROPERTY_SCHEMA_NAMES.REL_FORM_ID]: 'form_designer_related_form',
  [FIELD_PROPERTY_SCHEMA_NAMES.REL_FIELD]: 'form_designer_related_field',
  [FIELD_PROPERTY_SCHEMA_NAMES.CREATE_NEW_ELEMENT]: 'form_designer_create_new_element',
  [FIELD_PROPERTY_SCHEMA_NAMES.DROPDOWN_ONLY_ONE]: 'form_designer_show_only_one_item',
  [FIELD_PROPERTY_SCHEMA_NAMES.UNIQUE]: 'form_designer_unique_field',
  [FIELD_PROPERTY_SCHEMA_NAMES.MIN_LENGTH]: 'form_designer_minimum_length',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAX_LENGTH]: 'form_designer_maximum_length',
  [FIELD_PROPERTY_SCHEMA_NAMES.PATTERN]: 'form_designer_pattern',
  [FIELD_PROPERTY_SCHEMA_NAMES.DIRECT_INPUT_ENTRY]: 'form_designer_exact_value',
  [FIELD_PROPERTY_SCHEMA_NAMES.CALENDAR_OPTIONS]: 'form_designer_calendar_options',
  [FIELD_PROPERTY_SCHEMA_NAMES.TAGGABLE]: 'form_designer_taggable',
  [FIELD_PROPERTY_SCHEMA_NAMES.TEMPLATE_ITEM]: 'form_designer_template',
  [FIELD_PROPERTY_SCHEMA_NAMES.FORMATTED_TEXT]: 'form_designer_formatted_text',
  [FIELD_PROPERTY_SCHEMA_NAMES.OPTIONS_JSON]: 'form_designer_json_options',
  [FIELD_PROPERTY_SCHEMA_NAMES.IS_TECHNICAL]: 'form_designer_is_technical',
  [FIELD_PROPERTY_SCHEMA_NAMES.IS_STATIC]: 'form_designer_is_static',
  [FIELD_PROPERTY_SCHEMA_NAMES.MULTISELECT]: 'form_designer_multiselect',
  [FIELD_PROPERTY_SCHEMA_NAMES.THOUSAND_SEPARATED]: 'form_designer_thousand_separated',
  [FIELD_PROPERTY_SCHEMA_NAMES.DECIMAL]: 'form_designer_number_of_decimals',
  [FIELD_PROPERTY_SCHEMA_NAMES.FORM_DATA_PROCESS_ID]: 'form_designer_form_data_process_id',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAX_FILE_SIZE]: 'form_designer_maximum_file_size',
  [FIELD_PROPERTY_SCHEMA_NAMES.FILE_TYPES]: 'form_designer_file_types',
  [FIELD_PROPERTY_SCHEMA_NAMES.HTML_VALUE]: 'form_designer_html_value',
  [FIELD_PROPERTY_SCHEMA_NAMES.TIME_FORMAT]: 'form_designer_time_format',
  [FIELD_PROPERTY_SCHEMA_NAMES.IS_TIME_SELECT]: 'form_designer_is_time_select',
  [FIELD_PROPERTY_SCHEMA_NAMES.TIME_SELECT_FORM]: 'form_designer_time_select_form',
  [FIELD_PROPERTY_SCHEMA_NAMES.MIN]: 'form_designer_minimum_value',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAX]: 'form_designer_maximum_value',
  [FIELD_PROPERTY_SCHEMA_NAMES.MIN_EXP]: 'form_designer_minimum_value_by_expression',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAX_EXP]: 'form_designer_maximum_value_by_expression',
  [FIELD_PROPERTY_SCHEMA_NAMES.CAPTCHA_TYPE]: 'form_designer_captcha_type',
  [FIELD_PROPERTY_SCHEMA_NAMES.LINK_TYPE]: 'form_designer_link_type',
  [FIELD_PROPERTY_SCHEMA_NAMES.UNDERLINE]: 'form_designer_link_is_underlined',
  [FIELD_PROPERTY_SCHEMA_NAMES.PREFIX_ICON]: 'form_designer_link_icon',
  [FIELD_PROPERTY_SCHEMA_NAMES.PREFIX]: 'form_designer_number_prefix',
  [FIELD_PROPERTY_SCHEMA_NAMES.SUFFIX]: 'form_designer_number_suffix',
  [FIELD_PROPERTY_SCHEMA_NAMES.TIME_STEP]: 'form_designer_time_step',
  [FIELD_PROPERTY_SCHEMA_NAMES.END_TIME]: 'form_designer_end_time',
  [FIELD_PROPERTY_SCHEMA_NAMES.START_TIME]: 'form_designer_start_time',
  [FIELD_PROPERTY_SCHEMA_NAMES.VALUE_FROM_PARAM]: 'form_designer_default_value_from_external_param',
  [FIELD_PROPERTY_SCHEMA_NAMES.PROPERTY_OVERRIDE]: 'form_designer_overridden_properties',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAP_DATA_ENTITY]: 'form_designer_map_data_entity',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAP_PROPERTIES]: 'form_designer_map_properties',
  [FIELD_PROPERTY_SCHEMA_NAMES.MAP_DEFAULT_ADDRESS_EXP]: 'form_designer_default_address_expression',
  [FIELD_PROPERTY_NAMES.VALUE_IS_DEFAULT]: 'form_designer_eval_on_create',
  [FIELD_PROPERTY_NAMES.LIST_SOURCE]: 'form_designer_list_source',
  [FIELD_PROPERTY_NAMES.LIST_SOURCE_TYPE]: 'form_designer_list_source_type',
  [FIELD_PROPERTY_NAMES.LIST_SOURCE_FORM_ID]: 'form_designer_list_source_form',
  [FIELD_PROPERTY_NAMES.LIST_SOURCE_FIELD]: 'form_designer_list_source_field',
  [FIELD_PROPERTY_NAMES.SUB_ID_FORM]: 'form_designer_sub_form_id',
  [FIELD_PROPERTY_NAMES.SUB_FORM_PROPS]: 'form_designer_sub_form_props',
  [FIELD_PROPERTY_NAMES.SUB_COLUMN_NAME_SUB]: 'form_designer_sub_form_column_name',
  [FIELD_PROPERTY_NAMES.SUB_REC_EXTENDABLE]: 'form_designer_records_can_be_added',
  [FIELD_PROPERTY_NAMES.SUB_REC_DELETABLE]: 'form_designer_records_can_be_removed',
  [FIELD_PROPERTY_NAMES.SUB_MIN_NUMBER_OF_REC]: 'form_designer_minimum_number_of_records',
  [FIELD_PROPERTY_NAMES.SUB_MAX_NUMBER_OF_REC]: 'form_designer_maximum_number_of_records',
  [FIELD_PROPERTY_NAMES.SUBFORM_PURE]: 'form_designer_sub_form_pure',
  [FIELD_PROPERTY_NAMES.ROWS]: 'form_designer_textarea_rows',
  BY_EXPRESSION: 'form_designer_by_expression',
  CALENDAR: 'form_designer_calendar',
  COLLAPSED: 'form_designer_collapsed',
  DATE_PICKER: 'form_designer_datepicker',
  EDITABLE: 'form_designer_editable',
  ERROR: 'error',
  VISIBLE: 'visible',
  WARNING: 'warning',
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SUCCESS: 'success',
  DANGER: 'danger',
  INFO: 'info',
  UNDER_DEVELOPMENT: 'form_designer_under_development',
  DEPRECATED: 'form_designer_deprecated',
  NO_CAPTCHA: 'form_designer_no_captcha',
  RE_CAPTCHA: 'form_designer_reCaptcha',
  SPARTAN_CAPTCHA: 'form_designer_spartan_captcha',
  FORM: 'form',
  GENERATE_TABLE: 'form_designer_generate_table',
  ENUM_MANAGER_BUTTON: 'form_designer_navigate_to_enum_manager',
  SAVED_ONLY_ON_CREATE: 'form_designer_error_changing_after_save_is_not_possible',
  VALIDATION_UNIQUE_FORM_NAME: 'form_designer_error_form_name_must_be_unique',
  REQUIRED_UNIQUE_TRUE: 'form_designer_error_required_cannot_be_true_with_read_only_or_hidden',
  UNIQUE_FIELD_NAME: 'form_designer_error_field_name_must_be_unique',
  PLACEHOLDER_MENU_ASSIGNER: 'form_designer_placeholder_menu_assigner',
  FORM_PROPERTIES: 'form_designer_form_properties',
  FORM_LANGUAGE: 'form_designer_form_language',
  FORM_TECHNICAL: 'form_designer_form_technical',
  FIELD_PROPERTIES: 'form_designer_field_properties',
  FIELD_LANGUAGE: 'form_designer_field_language',
  FIELD_TECHNICAL: 'form_designer_field_technical',
  FIELD_VALIDATION: 'form_designer_field_validation',
  FIELD_APPEARANCE: 'form_designer_field_appearance',
  FIELD_BEHAVIOUR: 'form_designer_field_behaviour',
  FIELD_DATA: 'form_designer_field_data',
  FIELD_TYPE_TEXT: 'form_designer_field_text',
  FIELD_TYPE_EMAIL: 'form_designer_field_email',
  FIELD_TYPE_NUMBER: 'form_designer_field_number',
  FIELD_TYPE_PASSWORD: 'form_designer_field_password',
  FIELD_TYPE_LABEL: 'form_designer_field_label',
  FIELD_TYPE_RICH_TEXT: 'form_designer_field_richtext',
  FIELD_TYPE_EXPRESSION_EDITOR: 'form_designer_field_expressioneditor',
  FIELD_TYPE_COMMENT: 'form_designer_field_comment',
  FIELD_TYPE_DATETIME_LOCAL: 'form_designer_field_datetime_local',
  FIELD_TYPE_DATE: 'form_designer_field_date',
  FIELD_TYPE_TIME: 'form_designer_field_time',
  FIELD_TYPE_CHECKBOX: 'form_designer_field_checkbox',
  FIELD_TYPE_CHECKBOX_LIST: 'form_designer_field_checkboxlist',
  FIELD_TYPE_RADIOBUTTON_LIST: 'form_designer_field_radiobuttonlist',
  FIELD_TYPE_SQL_CHOSEN: 'form_designer_field_sqlchoosen',
  FIELD_TYPE_DROPDOWN_LIST: 'form_designer_field_dropdownlist',
  FIELD_TYPE_MULTISELECT: 'form_designer_field_multiselect',
  FIELD_TYPE_SUBFORM: 'form_designer_field_subform',
  FIELD_TYPE_WPAINT: 'form_designer_field_wpaint',
  FIELD_TYPE_GPS: 'form_designer_field_gps',
  FIELD_TYPE_SIGNATURE: 'form_designer_field_signature',
  FIELD_TYPE_CAMERAS: 'form_designer_field_cameras',
  FIELD_TYPE_SLIDER: 'form_designer_field_slider',
  FIELD_TYPE_MAP: 'form_designer_field_map',
  FIELD_TYPE_LINK: 'form_designer_field_link',
  FIELD_TYPE_RATING: 'form_designer_field_rating',
  FIELD_TYPE_CAPTCHA: 'form_designer_field_captcha',
  FIELD_TYPE_STATUS: 'form_designer_field_status',
  FD_FILTER_AVAILABLE_TABLES: 'form_designer_filter_available_tables',
  FD_TABLES_ADD_WHERE_CLAUSE: 'form_designer_add_tables_where_clause',
  FD_WHERE_KEY: 'form_designer_available_tables_where_key',
  FD_WHERE_VALUE: 'form_designer_available_tables_where_value',
  FD_TOOLBAR_OPTIONS: 'form_designer_toolbar_options',
  FD_FORM_SAVE: 'form_designer_save',
  FD_FORM_AVAILABLE_FEATURES: 'form_designer_form_available_features',
  FD_VERIFICATION_AVAILABLE_FEATURES: 'form_designer_verification_available_features',
  FD_PAGE_AVAILABLE_FEATURES: 'form_designer_page_available_features',
  FD_PAGE_ADD_AND_REMOVE: 'form_designer_page_add_and_remove',
  FD_GROUP_AVAILABLE_FEATURES: 'form_designer_group_available_features',
  FD_GROUP_ADD_AND_REMOVE: 'form_designer_group_add_and_remove',
  FD_PALETTE_AVAILABLE_ITEMS: 'form_designer_palette_available_items',
  FD_FIELD_AVAILABLE_FEATURES: 'form_designer_field_available_features',
  FD_FIELD_EDITABLE: 'form_designer_field_editable',
  FD_FIELD_REMOVABLE: 'form_designer_field_removable',
  FD_FIELD_FIX_WIDTH: 'form_designer_field_fix_width',
  FD_FIELD_IS_RESIZABLE: 'form_designer_field_is_resizable',
  FD_FIELD_TRANSFERABLE_BETWEEN_GROUPS: 'form_designer_field_transferable_between_groups',
  FD_FIELD_PROPERTIES: 'form_designer_field_properties',
  FD_ENABLE_FIELD_PROPERTIES: 'form_designer_enable_field_properties',
  FD_ENABLE_FORM_PROPERTIES: 'form_designer_enable_form_properties',
  FD_ENABLE_FIELD_LANGUAGE: 'form_designer_enable_field_language',
  FD_ENABLE_FIELD_DATA: 'form_designer_enable_field_data',
  FD_ENABLE_FIELD_VALIDATION: 'form_designer_enable_field_validation',
  FD_ENABLE_FIELD_APPEARANCE: 'form_designer_enable_field_appearance',
  FD_FIELD_BEHAVIOUR: 'form_designer_field_behaviour',
  FD_ENABLE_FIELD_BEHAVIOUR: 'form_designer_enable_field_behaviour',
  FD_FIELD_TECHNICAL: 'form_designer_field_technical',
  FD_ENABLE_FIELD_TECHNICAL: 'form_designer_enable_field_technical',
  FD_FIELD_ACTIVE_PROPERTIES: 'form_designer_field_active_properties',
  FD_ENABLE_FIELD_ACTIVE_PROPERTIES: 'form_designer_enable_field_active_properties',
  FD_GROUP_ACTIVE_PROPERTIES: 'form_designer_group_active_properties',
  FD_ENABLE_GROUP_ACTIVE_PROPERTIES: 'form_designer_enable_group_active_properties',
  FD_PAGE_ACTIVE_PROPERTIES: 'form_designer_page_active_properties',
  FD_ENABLE_PAGE_ACTIVE_PROPERTIES: 'form_designer_enable_page_active_properties',
  FD_FORM_ACTIVE_PROPERTIES: 'form_designer_form_active_properties',
  FD_ENABLE_FORM_ACTIVE_PROPERTIES: 'form_designer_enable_form_active_properties',
  FD_ADD_NEW_VALIDATION: 'form_designer_add_new_validation',
  FD_ADD_NEW_LIGHT_VALIDATION: 'form_designer_add_new_light_validation',
  SUB_ID_FORM_REQUIRED: 'form_designer_sub_id_form_is_required',
  REF_TABLE_REQUIRED: 'form_designer_ref_table_is_required',
  NAME_REQUIRED: 'form_designer_name_is_required',
  ID_SUBSYSTEM_REQUIRED: 'form_designer_subsystem_is_required',
  HOURS_MINUTES: 'HH:mm',
  HOURS_MINUTES_SECONDS: 'HH:mm:ss',
}
